<script setup>
import {computed, onMounted, ref, watch} from "vue";
import SearchIconComponent from "@/components/common/button/searchAndResetButton.vue";
import axios from "@/axios";
import {formatDate} from "@/plugins/dayjs";
import total_count from "@/components/common/totalCount/totalCount.vue";
import PagingComponent from "@/components/common/paging/pagingComponent.vue";
import PagePerItems from "@/components/common/paging/pagePerItems.vue";
import {VDateInput} from "vuetify/lib/labs/VDateInput";
import {useLanguageStore} from "@/pinia";
const languageStore = useLanguageStore();
const title = computed(() => languageStore.get('logManagement'));
const today = new Date();
const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
const todayEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate());
const searchDate = ref([todayStart, todayEnd]);
const searchId= ref(null);
const searchIp = ref(null);
const totalCount = ref(0);
const pageSize = ref(10);
const currentPage = ref(1)
const totalPage = ref(0);
const selectedLog =ref();
const searchType = ref(null);

const emits = defineEmits(['set_title'])

const logs = ref();
const fn_select = (data)=>{
  selectedLog.value = data;
}
const set_pageSize = (data)=>{
  pageSize.value = data;
  getLogs();
}
const set_currentPage = (data)=>{
  currentPage.value =data;
  getLogs();
}
const formatSearchDate = (date, isEnd) => {
  if (!date) return null;
  const d = new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return isEnd ? `${y}-${m}-${day}T23:59:59` : `${y}-${m}-${day}T00:00:00`;
}
const getLogs = ()=>{
  const data = {
    "startDate" : searchDate.value ? formatSearchDate(searchDate.value[0], false) : null,
    "endDate" : searchDate.value ? formatSearchDate(searchDate.value[searchDate.value.length-1], true) : null,
    "userId" : searchId.value ?searchId.value : null,
    "ipAddress" : searchIp.value ?searchIp.value : null,
    "logType" : searchType.value ?searchType.value : null,
    size : pageSize.value,
    page : currentPage.value-1,
  }
  axios.post('/api/logs', data,{headers: { 'Content-Type': 'application/json' }} )
      .then((s)=>{
        logs.value = s.data.content
        totalPage.value = s.data.totalPages
        totalCount.value = s.data.totalElements
      })
}
const fn_reset = ()=>{
  const now = new Date();
  const resetStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const resetEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  searchDate.value = [resetStart, resetEnd];
  searchId.value = null;
  searchIp.value = null;
  searchType.value = null;
  getLogs();
}
// 날짜 범위 최대 7일 제한
watch(searchDate, (newVal) => {
  if (newVal && newVal.length >= 2) {
    const start = new Date(newVal[0]);
    const end = new Date(newVal[newVal.length - 1]);
    const diffDays = Math.round((end - start) / (1000 * 60 * 60 * 24));
    if (diffDays > 7) {
      const maxEnd = new Date(start);
      maxEnd.setDate(maxEnd.getDate() + 7);
      searchDate.value = [newVal[0], maxEnd];
    }
  }
})

onMounted(()=>{
  getLogs();
  emits('set_title', title.value);
})
watch(title, (v) => emits('set_title', v))
</script>

<template>
  <div class="searchArea">
    <div class="searchCondition">
      <v-date-input
          class="search-field"
          :label="languageStore.get('period')"
          hide-details
          multiple="range"
          v-model="searchDate"
          variant="outlined"
          density="compact"
      ></v-date-input>
      <v-text-field
          class="search-field"
          type="text"
          variant="outlined"
          density="compact"
          :label="languageStore.get('userId')"
          hide-details
          v-model="searchId"
          @keyup.enter="() => { currentPage = 1; getLogs(); }"
      ></v-text-field>
      <v-text-field
          class="search-field"
          type="text"
          variant="outlined"
          density="compact"
          :label="languageStore.get('filterType')"
          hide-details
          v-model="searchType"
          @keyup.enter="() => { currentPage = 1; getLogs(); }"
      ></v-text-field>
      <v-text-field
          class="search-field"
          type="text"
          variant="outlined"
          density="compact"
          :label="languageStore.get('ipAddress')"
          hide-details
          v-model="searchIp"
          @keyup.enter="() => { currentPage = 1; getLogs(); }"
      ></v-text-field>
    </div>
    <search-icon-component
        @fn_search="() => { currentPage = 1; getLogs(); }"
        @fn_reset="fn_reset"
    ></search-icon-component>
  </div>
  <div class="mainContentArea">
    <div class="contentTopArea">
      <total_count
          :total-count="totalCount"
      ></total_count>
      <div class="contentTopRight">
        <page-per-items
            :page-per-items="pageSize"
            @set_pageSize="set_pageSize"
        ></page-per-items>
      </div>
    </div>
    <div class="contentDataArea">
      <div class="contentHead">
        <div class="">{{ languageStore.get('id') }}</div>
        <div class="">{{ languageStore.get('requestUrl') }}</div>
        <div class="">{{ languageStore.get('requestType') }}</div>
        <div class="">{{ languageStore.get('ipAddress') }}</div>
        <div class="">{{ languageStore.get('message') }}</div>
        <div class="">{{ languageStore.get('accessDate') }}</div>
      </div>
      <div class="contentBody">
        <template v-if="totalCount >0">
          <template v-for="log in logs" :key="log.logId">
            <div class="logList" :class="{on : log.logId === selectedLog}" @click="fn_select(log.logId)">
              <div>{{log.userId}}</div>
              <div>{{log.requestPath}}</div>
              <div>{{log.requestMethod}}</div>
              <div>{{log.ipAddress}}</div>
              <div>{{log.message}}</div>
              <div>{{formatDate(log.logDt, 'YYYY-MM-DD HH:mm:ss')}}</div>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="noData">
            <v-icon size="36" color="#B0BEC5">mdi-database-off-outline</v-icon>
            <p>{{languageStore.get('noData')}}</p>
          </div>
        </template>
      </div>
    </div>
  </div>
  <div class="pagingArea">
    <paging-component
        @set_currentPage="set_currentPage"
        :page="currentPage"
        :total-page=totalPage
    ></paging-component>
  </div>
</template>

<style scoped>
.searchArea{
  background: white;
  position: relative;
  width: 70vw;
  height: 8vh;
  margin: 10px 0 10px 0;
  padding: 0 20px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}
.search-field {
  min-width: 150px;
  max-width: 200px;
}
.mainContentArea{
  background: white;
  width: 70vw;
  height: 70vh;
  border-radius: 5px;
  overflow-y: auto;
  overflow-x: hidden;
}
.contentTopArea{
  display: flex;
  justify-content: space-between;
  height: 6vh;
  align-items: center;
  padding: 1px 10px 0px 10px;
}
.datePickArea{
  display: flex;
  align-items: center;
}
.searchCondition{
  display: flex;
  width: 100%;
}
.searchCondition div{
  padding: 1rem;
}
.contentHead{
  display: grid;
  grid-template-columns: repeat(6,1fr);
  background: #052C65;
  color: white;
  height: 4vh;
  align-items: center;
  font-weight: bold;
}
.contentHead div{
  display: flex;
  align-items: center;
  justify-content: center;
}
.logList{
  display: grid;
  grid-template-columns: repeat(6,1fr);
  align-items: center;
  height: 5vh;
  border-bottom: 1px solid #C7C7C7;
  cursor: pointer;
  font-size: 14px;
  padding: 10px;
}
.on{
  background-color: #E0F0FF;
  cursor:default;
}
.pagingArea{
  display: flex;
  justify-content: center;
}
.noData {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #90A4AE;
  font-size: 14px;
  gap: 8px;
}
</style>